import { EntityResponseSchema } from '../schemas'
import { http } from './http'
import { auth } from './auth'
import { parseWithZod } from '../utils/parse-with-zod'

export const entities = {
  /**
   * Creates an entity on the deal. The backend also creates a placeholder signing position for it —
   * so the first signing officer added to a brand-new entity mutates that position rather than
   * creating another one.
   */
  create: async (dealId: number, payload: { name: string }) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(
      `${regionHost}/api/entities`,
      { entity: { ...payload, deal_id: dealId } },
      dealId,
    )
    return parseWithZod(EntityResponseSchema, result).entity
  },

  update: async (id: number, payload: { name: string; description?: string }, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.put(
      `${regionHost}/api/entities/${id}`,
      { entity: { ...payload, deal_id: dealId } },
      dealId,
    )
    return parseWithZod(EntityResponseSchema, result).entity
  },

  delete: async (id: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    await http.delete(`${regionHost}/api/entities/${id}`, dealId)
  },
}
